// İş Emirleri (WMS toplama dalgaları) sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'wms.waves';

export const wmsWavesGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'İş Emirleri nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'İş emri, bir toplayıcının tek turda toplayacağı sipariş grubudur. Burada iş emirlerini izler, toplayıcı ve araba atayıp başlatır, gerekirse iptal edersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve Depo'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Durum, Tip, arama'),
    toolbar: t(`${G}.regions.toolbar`, 'Akıllı İş Emri, Toplu Ata'),
    table: t(`${G}.regions.table`, 'İş emri listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Depoyu seçin, kartları okuyun'),
      text: t(`${G}.s1.text`, 'Sağ üstten akıllı depoyu seçin. Kartlar Oluşturulan, Devam Eden, Tamamlanan ve İptal iş emri sayılarını, ayrıca Toplam Ürün ve Toplanan Ürün adedini gösterir. Durum kartına tıklamak listeyi o duruma süzer.'),
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Listeyi süzün'),
      text: t(`${G}.s2.text`, '"Durum" (Oluşturuldu, Devam Ediyor, Tamamlandı, İptal), "Tip" (Tekli, Çoklu) ve arama kutusu (iş emri no veya toplayıcı) ile listeyi daraltın. Tekli iş emrinde her sipariş tek adet üründen oluşur; çoklu iş emrinde ürünler toplu toplanır, sonra raflamada siparişlere ayrılır.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Akıllı İş Emri oluşturun'),
      text: t(`${G}.s3.text`, '"Akıllı İş Emri" bekleyen siparişleri benzerliğe göre gruplar. Sipariş Tipi (Tekli / Çoklu), Gruplama Tipi (Otomatik, Aynı ürün, Varyant ailesi, Kategori, Konum / koridor), Max Sipariş / İş Emri, Max Kalem / İş Emri ve "Acil öne al" seçip "Grupları Hesapla"ya basın. İstediğiniz grupları seçip "İş Emirlerini Oluştur" deyin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Otomatik modda öncelik sırası: aynı ürün → varyant ailesi → konum yakınlığı → kategori.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Satırı okuyun, ayrıntıya bakın'),
      text: t(`${G}.s4.text`, 'Her satırda İş Emri No, Tip, sipariş ve ürün sayısı, Toplayıcı, Araba, Durum ve Tarih görünür; devam edenlerde ilerleme çubuğu çıkar. Devam eden ve tamamlanan iş emrinde göz simgesi ayrıntıyı açar.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Hazırlayıp başlatın'),
      text: t(`${G}.s5.text`, '"Oluşturuldu" durumundaki iş emrinde "Hazırla" düğmesi (ya da Toplayıcı / Araba hücresine tıklamak) hazırlama sihirbazını açar: toplayıcı seçin, araba seçin, özeti kontrol edip "Başlat"a basın. Başlayınca siparişler toplamaya alınır ve toplayıcı el terminalinde iş emrini görür.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s6.title`, '6. Toplu toplayıcı atayın'),
      text: t(`${G}.s6.text`, 'Yalnız "Oluşturuldu" durumunda ve toplayıcısı olmayan iş emirleri işaretlenebilir. Birkaç tanesini işaretleyip "Seçilenleri Toplayıcıya Ata"ya basın, toplayıcıyı seçip "Toplu Ata" deyin. Atanamayan iş emirleri varsa nedenleriyle birlikte gösterilir ve seçili kalır.'),
      tips: [
        t(`${G}.s6.tip1`, 'Listede bu depodaki Toplama ekranına yetkili personel çıkar. Depoda Toplama ekranı yoksa tüm personel listelenir.'),
        t(`${G}.s6.tip2`, 'Toplu atama iş emrini başlatmaz; başlatmak için her birinde "Hazırla" ile araba seçip "Başlat"a basın.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s7.title`, '7. İptal ve silme'),
      text: t(`${G}.s7.text`, '"Oluşturuldu" durumundaki iş emri iptal simgesiyle iptal edilir; onay sorulur. İptalde siparişler yeniden "Bekleyen" durumuna döner ve atanmış araba boşa çıkar. İptal edilmiş iş emri çöp kutusu simgesiyle listeden silinir. Tamamlanmış iş emri iptal edilemez.'),
    },
  ],
});
